const state = {
  notificacaoAtual: Array
}

const mutations = {
  setNotificacaoAtual (state, obj) {
    state.notificacaoAtual = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/notificacaoAtual.js